/* DN5 · Collection 2c — filters / sort / load more / grid / swatches / toast. All events delegated, so it survives section re-renders. */
(function () {
  if (window.__dn5c) return; window.__dn5c = 1;
  var D = document, LS = 'dn5c_cols';
  var mqD = window.matchMedia('(min-width: 990px)');
  var root = function () { return D.querySelector('[data-dn5c]'); };
  var form = function () { var r = root(); return r && r.querySelector('[data-dn5c-form]'); };
  var base = function () { var f = form(); return f ? f.getAttribute('action') : location.pathname; };
  var withSection = function (url) { var r = root(); var u = new URL(url, location.origin); u.searchParams.set('section_id', r.dataset.sectionId); return u.toString(); };
  var clean = function (url) { var u = new URL(url, location.origin); u.searchParams.delete('section_id'); return u.pathname + u.search; };

  function formUrl() {
    var f = form(), p = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (k.indexOf('dn5c_') === 0 || v === '') return; p.append(k, v); });
    var q = p.toString(); return base() + (q ? '?' + q : '');
  }
  function fetchSection(url) { return fetch(withSection(url), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) { return new DOMParser().parseFromString(h, 'text/html').querySelector('[data-dn5c]'); }); }

  var seq = 0;
  function swap(url, opts) {
    opts = opts || {}; var r = root(); if (!r) return; var my = ++seq;
    r.classList.add('is-loading');
    fetchSection(url).then(function (n) {
      if (my !== seq || !n) return;
      var keepSheet = opts.keepSheet && r.classList.contains('is-sheet');
      r.replaceWith(n);
      if (window.dn && window.dn.bundle && typeof window.dn.bundle.fill === 'function') window.dn.bundle.fill(n);
      applyCols(); initBands(); initDots(); initRatings(n);
      if (keepSheet) n.classList.add('is-sheet'); else D.documentElement.style.overflow = '';
      history.replaceState(null, '', clean(url));
    }).catch(function () { location.href = clean(url); });
  }
  function previewCount() {
    var my = ++seq, url = formUrl();
    fetchSection(url).then(function (n) {
      if (my !== seq || !n) return;
      var t = n.querySelector('[data-dn5c-total]'), r = root(),
          o = r.querySelector('[data-dn5c-apply-n]'), w = r.querySelector('[data-dn5c-apply-w]');
      if (t && o) {
        var c = t.getAttribute('data-dn5c-total');
        o.textContent = c;
        if (w) w.textContent = (c === '1') ? 'RESULT' : 'RESULTS';   /* a single item does not write RESULTS */
      }
    });
  }

  /* grid columns */
  function applyCols() {
    var r = root(); if (!r) return; var c = {}; try { c = JSON.parse(localStorage.getItem(LS) || '{}'); } catch (e) {}
    r.classList.toggle('is-m1', c.m === 'm1'); r.classList.toggle('is-d3', c.d === 'd3');
    r.querySelectorAll('[data-dn5c-cols]').forEach(function (b) { var v = b.dataset.dn5cCols; b.classList.toggle('is-on', v === (c.m || 'm2') || v === (c.d || 'd4')); });
  }
  /* price band highlight from hidden inputs */
  function initBands() {
    var r = root(); if (!r) return;
    r.querySelectorAll('[data-dn5c-price]').forEach(function (g) {
      var lo = g.querySelector('[data-dn5c-min]').value, hi = g.querySelector('[data-dn5c-max]').value;
      g.querySelectorAll('[data-dn5c-band]').forEach(function (b) { b.classList.toggle('is-on', (lo || hi) && String(+b.dataset.lo || '') === String(+lo || '') && String(+b.dataset.hi || '') === String(+hi || '')); });
    });
  }
  function initDots() {}

  function selectCardDot(dot) {
    var card = dot.closest('[data-dn5c-card]'); if (!card) return;
    card.querySelectorAll('[data-dn5c-dot]').forEach(function (x) { x.classList.toggle('is-on', x === dot); });
    var img = card.querySelector('.dn5c-card__img'); if (img && dot.dataset.img) { img.removeAttribute('srcset'); img.src = dot.dataset.img; }
    var qa = card.querySelector('[data-quick-add]'); if (qa && dot.dataset.variant) qa.setAttribute('data-quick-add', dot.dataset.variant);
    var cv = card.querySelector('[data-dn5c-cname-v]'); if (cv) cv.textContent = dot.dataset.name;
  }

  function setSheet(on) { var r = root(); if (!r) return; r.classList.toggle('is-sheet', on); D.documentElement.style.overflow = on ? 'hidden' : ''; }
  function inPanel(el) { return !!el.closest('[data-dn5c-panel]'); }
  function changed(el) { if (!mqD.matches && inPanel(el)) previewCount(); else swap(formUrl(), { keepSheet: true }); }

  D.addEventListener('change', function (e) {
    var el = e.target; if (!el.closest || !el.closest('[data-dn5c-form]')) return;
    if (el.matches('[data-dn5c-sort-m]')) { form().querySelector('[data-dn5c-sort-input]').value = el.value; }
    var lab = el.closest('label'); if (lab && el.type === 'radio') { lab.parentNode.querySelectorAll('label').forEach(function (l) { l.classList.toggle('is-on', l === lab); }); }
    else if (lab) lab.classList.toggle('is-on', el.checked);
    changed(el);
  });

  D.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var relatedDot = t.closest('[data-dn5c-dot]');
    if (relatedDot && relatedDot.closest('[data-ymal-track]')) { e.preventDefault(); selectCardDot(relatedDot); return; }
    var r = root(); if (!r || !r.contains(t)) return;
    var b;
    if (t.closest('[data-dn5c-open]')) { setSheet(true); return; }
    if (t.closest('[data-dn5c-close]')) { setSheet(false); return; }
    if (t.closest('[data-dn5c-apply]')) { setSheet(false); swap(formUrl()); return; }
    if (t.closest('[data-dn5c-clear]')) { var s = form().querySelector('[data-dn5c-sort-input]').value; setSheet(false); swap(base() + (s ? '?sort_by=' + encodeURIComponent(s) : '')); return; }
    if ((b = t.closest('[data-dn5c-nav]'))) { e.preventDefault(); swap(b.href); return; }
    if ((b = t.closest('[data-dn5c-sort-toggle]'))) { var w = b.parentNode; w.classList.toggle('is-open'); b.setAttribute('aria-expanded', w.classList.contains('is-open')); return; }
    if ((b = t.closest('[data-dn5c-sort]'))) { form().querySelector('[data-dn5c-sort-input]').value = b.dataset.dn5cSort; swap(formUrl()); return; }
    if ((b = t.closest('[data-dn5c-band]'))) {
      var g = b.closest('[data-dn5c-price]'), on = !b.classList.contains('is-on');
      g.querySelector('[data-dn5c-min]').value = on ? b.dataset.lo : ''; g.querySelector('[data-dn5c-max]').value = on ? b.dataset.hi : '';
      g.querySelectorAll('[data-dn5c-band]').forEach(function (x) { x.classList.toggle('is-on', on && x === b); });
      changed(b); return;
    }
    if ((b = t.closest('[data-dn5c-cols]'))) {
      var c = {}; try { c = JSON.parse(localStorage.getItem(LS) || '{}'); } catch (x) {}
      var v = b.dataset.dn5cCols; if (v[0] === 'm') c.m = v; else c.d = v;
      try { localStorage.setItem(LS, JSON.stringify(c)); } catch (x) {} applyCols(); return;
    }
    if ((b = t.closest('[data-dn5c-tag]'))) {
      var tag = b.dataset.dn5cTag;
      r.querySelectorAll('[data-dn5c-tag]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      var n = 0; r.querySelectorAll('[data-dn5c-card]').forEach(function (cd) { var ok = !tag || (cd.dataset.productTags || '').split('|').indexOf(tag) >= 0; cd.hidden = !ok; if (ok) n++; });
      var bt = r.querySelector('[data-dn5c-bundle]'); if (bt) bt.hidden = !!tag; return;
    }
    if ((b = t.closest('[data-dn5c-dot]'))) {
      e.preventDefault(); selectCardDot(b);
      return;
    }
    if ((b = t.closest('[data-dn5c-loadmore]'))) {
      e.preventDefault(); if (b.classList.contains('is-loading')) return; b.classList.add('is-loading');
      fetchSection(b.href).then(function (n) {
        var grid = r.querySelector('[data-dn5c-grid]'), ng = n && n.querySelector('[data-dn5c-grid]');
        if (grid && ng) ng.querySelectorAll('[data-dn5c-card]').forEach(function (cd) { grid.appendChild(cd); });
        initRatings(grid);   /* newly loaded cards also get the lazy rating fetch */
        var nm = n && n.querySelector('[data-dn5c-more]'), om = r.querySelector('[data-dn5c-more]');
        if (nm && om) om.replaceWith(nm);
        history.replaceState(null, '', location.pathname + location.search);
      }).catch(function () { location.href = b.href; });
    }
  });
  D.addEventListener('click', function (e) { var r = root(); if (!r) return; var s = r.querySelector('.dn5c-sort.is-open'); if (s && !s.contains(e.target)) s.classList.remove('is-open'); });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setSheet(false); var r = root(); var s = r && r.querySelector('.dn5c-sort.is-open'); if (s) s.classList.remove('is-open'); } });
  mqD.addEventListener && mqD.addEventListener('change', function () { setSheet(false); });

  /* bundle-progress toast after Quick Add (theme.js fires cart:refresh) */
  var tt;
  D.addEventListener('cart:refresh', function () {
    var r = root(); if (!r || r.dataset.toastOn !== 'true') return;
    fetch(window.dnRoute('cart.js'), { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (cart) {
      var n = 0; (cart.items || []).forEach(function (it) { if (!(it.properties && it.properties._dn4_gift)) n += it.quantity; });
      if (!n) return; var it = cart.items[0];
      var el = root().querySelector('[data-dn5c-toast]'); if (!el) return;
      el.querySelector('[data-dn5c-toast-t]').textContent = it.product_title + (it.variant_title ? ' · ' + it.variant_title.replace(/ \/ /g, ' · ') : '');
      /* {pct_2} / {pct_3} come from the engine (window.dn.bundle.text, ENGINE-CONTRACT §6.7); unresolvable = no sub line */
      var sub = r.getAttribute('data-toast-' + Math.min(n, 3)) || '', B = window.dn && window.dn.bundle;
      sub = B ? B.text(sub, r.getAttribute('data-bd-handle') || '') : (/\{pct(_\d+|_max)?\}/.test(sub) ? null : sub);
      el.querySelector('[data-dn5c-toast-s]').textContent = sub || '';
      el.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('is-on'); }, 3000);
    }).catch(function () {});
  });

  /* ── lazy rating fetch (2026-10-17) ─────────────────────────────────────────
     The truth lives in the avalonae-reviews app proxy, not in the standard Shopify metafield:
       /apps/reviews/product-reviews?handle=<handle>&product_id=<id>
     Measured (all 43 active products hit one by one): 26 have reviews, 4391 in total; reviews.rating = 0 store-wide.
     🔴 product_id is required — with handle only the endpoint returns total_count:0, silently short, no error.
     🔴 No batch support: handles=a,b returns an object without even total_count, handle=a,b returns 0.
        So 24 cards per page cannot be fetched at once: fetch on entering the viewport + once per handle + max 4 in flight.
     No reviews = stay hidden, never draw empty stars. */
  var rateCache = {}, rateQueue = [], rateActive = 0, RATE_MAX = 4;

  function rateDraw(el, data) {
    var n = (data && data.total_count) || 0;
    if (!n) return;                       // no reviews: container stays hidden
    var avg = Math.round(((data.average_rating || 0) * 10)) / 10;
    el.innerHTML = '<b>★</b>' + avg.toFixed(1) + ' <span>(' + n + ')</span>';
    el.hidden = false;
  }

  function ratePump() {
    while (rateActive < RATE_MAX && rateQueue.length) {
      (function (job) {
        rateActive++;
        var key = job.handle;
        if (rateCache[key]) { rateActive--; rateDraw(job.el, rateCache[key]); ratePump(); return; }
        fetch('/apps/reviews/product-reviews?handle=' + encodeURIComponent(job.handle) +
              '&product_id=' + encodeURIComponent(job.id), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { if (j) { rateCache[key] = j; rateDraw(job.el, j); } })
          .catch(function () { /* nothing fetched = keep hidden, never draw half a widget */ })
          .then(function () { rateActive--; ratePump(); });
      })(rateQueue.shift());
    }
  }

  var rateObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; rateObs.unobserve(el);
      if (el.getAttribute('data-rate-done')) return;
      el.setAttribute('data-rate-done', '1');
      var h = el.getAttribute('data-rate-handle'), id = el.getAttribute('data-rate-id');
      if (!h || !id) return;
      if (rateCache[h]) { rateDraw(el, rateCache[h]); return; }
      rateQueue.push({ el: el, handle: h, id: id }); ratePump();
    });
  }, { rootMargin: '300px 0px' }) : null;

  function initRatings(scope) {
    if (!rateObs) return;
    (scope || D).querySelectorAll('[data-dn5c-rate]:not([data-rate-seen])').forEach(function (el) {
      el.setAttribute('data-rate-seen', '1'); rateObs.observe(el);
    });
  }

  function boot() { applyCols(); initBands(); initRatings(); }
  if (D.readyState !== 'loading') boot(); else D.addEventListener('DOMContentLoaded', boot);
})();
